import axios from 'axios';
import mixin from "@/mixin/index.js";
import parameters from "@/constants/parameters.js";
import modules from "@/store/index.js";
import messages from '@/constants/messages.js';
import jwt from 'jsonwebtoken';
const root = { root: true };

const getToken = async function (refreshToken = false) {
    let user = modules.getters['general/user'];
    if (modules.getters['purchases/recentPurchase']) {
        refreshToken = true;
        modules.commit('purchases/setRecentPurchase', false, root);
    }
    if (user.token
        && (user.tokenExpire * 1000 > mixin.methods._getTimestamp())
        && !refreshToken) {
        return user.token;
    }
    const url = `/login/${user.uid}/tokens`;
    const body = { user: mixin.methods._encrypt(user) };
    try {
        const payload = await post(url, body);
        if (user.uid) {
            const { claims } = jwt.decode(payload.token);
            user = { ...payload.user, ...claims };
            user['token'] = payload.token;
            user['tokenExpire'] = parseInt(mixin.methods._getTimestamp() / 1000) + 2400;
            modules.dispatch(
                'general/saveUserOnApp',
                {
                    user,
                    hasRedirect: false
                },
                root
            );
        }
        return payload.token;
    } catch (err) {
        if (!!err && !!err.response && err.response.status == 403) {
            modules.commit(
                'general/setConfirmModel',
                {
                    text: messages.USER_DELETED,
                    confirmText: mixin.methods._getLabel("CONTINUE"),
                    active: true,
                    alert: true,
                },
                root
            );
            modules.dispatch('general/completeLogout', null, root);
        }
        throw err;
    }
}

const request = async function (timeout = 20000, headers = {}, hasToken = false, refreshToken = false) {
    const user = modules.getters['general/user'];
    if (hasToken) {
        if (!user || !user.uid) {
            modules.dispatch('general/completeLogout', null, root);
            throw new Error('Error!');
        }
        headers['token'] = await getToken(refreshToken);
    }
    headers['x-api-key'] = process.env.VUE_APP_API_KEY || '';
    headers['version'] = parameters.APP_VERSION;
    headers['platform'] = mixin.methods._getPlatform();
    headers['client-time'] = mixin.methods._getTimestamp();

    if (user && !headers['user'] && !headers['token']) {
        headers['user'] = user.uid;
    }
    return axios.create({
        baseURL: process.env.VUE_APP_BASE_URL,
        timeout: timeout || 20000,
        headers: headers || {}
    })
}

const post = async (url, body, timeout, headers) => {
    const http = await request(timeout, headers);
    const response = await http.post(url, body);
    if (response.data.payload) {
        return mixin.methods._decrypt(response.data.payload);
    }
    return response.data.payload;
}

const getAsync = async ({ url, timeout, headers, hasToken, refreshToken = false } = {}) => {
    const http = await request(timeout, headers, hasToken, refreshToken);
    const response = await http.get(url);
    return mixin.methods._decrypt(response.data.payload);
}

const postAsync = async ({ url, body, timeout, headers, hasToken, refreshToken = false } = {}) => {
    const http = await request(timeout, headers, hasToken, refreshToken);
    const response = await http.post(url, body);
    if (response.data.payload) {
        return mixin.methods._decrypt(response.data.payload);
    }
    return response.data.payload;
}

const deleteAsync = async ({ url, timeout, headers, hasToken, refreshToken = false } = {}) => {
    const http = await request(timeout, headers, hasToken, refreshToken);
    const response = await http.delete(url);
    if (response.data.payload) {
        return mixin.methods._decrypt(response.data.payload);
    }
    return response.data.payload;
}

export default {
    get: async (url, timeout, headers) => {
        const http = await request(timeout, headers);
        const response = await http.get(url);
        return mixin.methods._decrypt(response.data.payload);
    },
    getAsync,
    post,
    postAsync,
    deleteAsync,
    getToken
}
